import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../api.js';
import { Doodle, Reveal } from '../Doodles.jsx';

export default function Catalogo() {
  const [cats, setCats] = useState([]);
  const [products, setProducts] = useState([]);
  const [params, setParams] = useSearchParams();
  const cat = params.get('cat') || '';

  useEffect(() => { api.categories().then(setCats).catch(() => {}); }, []);
  useEffect(() => {
    api.products(cat ? `?categoria=${cat}` : '').then(setProducts).catch(() => {});
  }, [cat]);

  return (
    <div className="page">
      <div className="page-head">
        <p className="kicker hand" style={{ justifyContent: 'center', fontSize: '1.3rem' }}>
          <Doodle name="cupcake" size={26} color="var(--mint-d)" /> Carta · pedidos por encargo
        </p>
        <h1>Nuestros dulces</h1>
      </div>

      <div className="filters">
        <button className={!cat ? 'chip chip--on' : 'chip'} onClick={() => setParams({})}>Todo</button>
        {cats.map((c) => (
          <button key={c.slug} className={cat === c.slug ? 'chip chip--on' : 'chip'}
            onClick={() => setParams({ cat: c.slug })}>{c.nombre}</button>
        ))}
      </div>

      <div className="prod-grid">
        {products.map((p, i) => (
          <Reveal key={p.slug} delay={(i % 4) * 0.07} y={24}>
            <Link to={`/producto/${p.slug}`} className="prod-card">
              <div className="prod-img" style={{ backgroundImage: `url(${p.imagenes?.[0]})` }} />
              <div className="prod-meta">
                <h3>{p.nombre}</h3>
                <p className="prod-desc">{p.descripcion}</p>
                <span className="price">desde {p.precioBase} €</span>
              </div>
            </Link>
          </Reveal>
        ))}
        {products.length === 0 && (
          <p className="empty">Aún no hay dulces en esta categoría… ¿echas un vistazo al resto?</p>
        )}
      </div>
    </div>
  );
}
